<section class="minimum-stock" [class.embedded]="embedded" [class.compact]="compact" [class.common-warning]="!!groupWarning">
  <button
    *ngIf="!embedded"
    type="button"
    mat-button
    class="section-toggle"
    [attr.aria-expanded]="expanded"
    [attr.aria-controls]="'minimum-stock-editor-' + productId + '-' + showSuggestions"
    (click)="toggle()"
  >
    <mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    Минимальные остатки по складам
  </button>
  <h3 *ngIf="embedded">Минимальные остатки по складам</h3>
  <div *ngIf="expanded" [id]="'minimum-stock-editor-' + productId + '-' + showSuggestions" class="editor">
    <p class="hint" *ngIf="!compact">
      Для этого товара на всех складах, независимо от фильтров отчёта. 0 — минимум не задан.
      Сохраняйте изменения отдельно для каждого склада.
    </p>
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
    <p *ngIf="loading" role="status" class="hint">Загрузка складов…</p>
    <div *ngIf="error" class="error" role="alert">
      {{ error }}
      <button type="button" mat-button (click)="load()">Повторить</button>
    </div>
    <p *ngIf="loaded && !rows.length" class="hint">Склады не найдены.</p>
    <div *ngIf="showSuggestions && loaded && rows.length" class="suggestion-controls">
      <div class="suggestion-heading">
        <strong>Предложение системы</strong>
        <p class="hint">
          Чистые продажи ÷ дни периода × дни запаса, с округлением вверх.
          {{ familySources.length ? 'Группа товара и аналогов; для этого товара вычитаются минимумы остальных аналогов.' : 'Только этот товар, отдельно по каждому складу.' }}
        </p>
      </div>
      <mat-form-field appearance="outline" class="coverage-input">
        <mat-label>Запас, дней</mat-label>
        <input
          matInput
          type="number"
          min="1"
          max="365"
          step="1"
          required
          [ngModel]="coverageDays"
          (ngModelChange)="changeCoverageDays($event)"
          (keydown.enter)="suggest()"
        />
        <mat-error>От 1 до 365 целых дней</mat-error>
      </mat-form-field>
      <button
        type="button"
        mat-stroked-button
        color="primary"
        class="suggest-button"
        [disabled]="suggesting || !suggestionsReady || !validCoverage() || !dateFrom || !dateTo"
        (click)="suggest()"
      >
        {{ suggesting ? 'Расчёт…' : 'Предложить минимумы' }}
      </button>
      <p class="hint suggestion-note">
        Продажи за {{ dateFrom | date: 'dd.MM.yyyy' }} — {{ dateTo | date: 'dd.MM.yyyy' }}.
        Сезонность, сроки поставки и периоды отсутствия товара пока не учитываются. Предложение —
        минимальный запас, а не количество к закупке.
      </p>
      <p *ngIf="!validCoverage()" class="error suggestion-note" role="alert">
        Введите от 1 до 365 целых дней.
      </p>
      <mat-progress-bar
        *ngIf="suggesting"
        mode="indeterminate"
        class="suggestion-note"
      ></mat-progress-bar>
      <p *ngIf="suggestionError" class="error suggestion-note" role="alert">
        {{ suggestionError }}
      </p>
      <p *ngIf="suggestions" class="hint suggestion-note" role="status">
        Расчёт на {{ suggestions.coverageDays }} дней по {{ suggestions.periodDays }} дням истории.
        «Подставить» переносит предложение в поле. Для применения нажмите «Сохранить» у нужного
        склада.
      </p>
    </div>
    <details class="compact-explanation" *ngIf="compact">
      <summary>Как рассчитывается минимум</summary>
      <p>{{ familySources.length ? 'Общий минимум группы = чистые продажи товара и аналогов ÷ дни периода × дни запаса, округление вверх. Предложение для этого товара = минимум группы минус уже заданные минимумы других аналогов, не меньше 0.' : 'Минимум = чистые продажи этого товара ÷ дни периода × дни запаса, с округлением вверх.' }}</p>
      <p>0 — минимум не задан. «Подставить» меняет поле; «Сохранить» применяет его только к этому товару на выбранном складе. Сезонность, срок поставки и отсутствие товара не учитываются.</p>
    </details>
    <div *ngIf="compact && groupWarning" class="family-warning" role="alert">
      <span>{{ familyBlockers.length ? 'Расчёт запаса с аналогами заблокирован.' : groupWarning }}</span>
      <ul *ngIf="familyBlockers.length"><li *ngFor="let reason of familyBlockers">{{ reason }}</li></ul>
    </div>
    <div class="compact-columns" *ngIf="compact && loaded && rows.length"><span>Склад · остаток товара</span><span>Предложение для товара</span><span>Минимум</span><span></span></div>
    <div class="warehouse-row" *ngFor="let row of rows; trackBy: trackWarehouse">
      <div class="warehouse">
        <strong>{{ row.warehouseName }}</strong>
        <span>На складе: {{ row.quantity | number: '1.0-3' }} {{ unit }}</span>
        <div *ngIf="row.suggestion as suggestion" class="suggestion">
          <div class="suggestion-value">
            <strong *ngIf="suggestion.suggestedMinimum !== null">
              Предложение: {{ suggestion.suggestedMinimum | number: '1.0-0' }} {{ unit }}
            </strong>
            <strong *ngIf="suggestion.suggestedMinimum === null">Нужна ручная оценка</strong>
            <button
              *ngIf="suggestion.suggestedMinimum !== null"
              type="button"
              mat-button
              color="primary"
              [disabled]="row.saving || row.draft === suggestion.suggestedMinimum"
              [attr.aria-label]="'Подставить предложение: ' + row.warehouseName"
              (click)="useSuggestion(row)"
            >
              Подставить
            </button>
          </div>
          <span class="suggestion-details">
            Отгружено {{ suggestion.soldQty | number: '1.0-3' }} · возвращено
            {{ suggestion.returnedQty | number: '1.0-3' }} · чистые продажи
            {{ suggestion.netQty | number: '1.0-3' }} {{ unit }} · отгрузок
            {{ suggestion.shipmentCount }}
          </span>
          <span class="suggestion-details" *ngIf="suggestion.suggestedMinimum !== null">
            В среднем {{ suggestion.averageDailyQty | number: '1.0-3' }} {{ unit }}/день
          </span>
          <span class="family-basis" *ngIf="suggestion.groupMinimum !== undefined && suggestion.groupMinimum !== null">
            Группе нужно {{ suggestion.groupMinimum }} · у других аналогов задано {{ suggestion.otherMinimum }}
          </span>
          <span *ngIf="suggestionStatus(suggestion)" class="suggestion-warning">{{
            suggestionStatus(suggestion)
          }}</span>
        </div>
      </div>
      <mat-form-field appearance="outline" class="minimum-input">
        <mat-label>Минимум, {{ unit }}</mat-label>
        <input
          matInput
          type="number"
          min="0"
          max="1000000"
          step="1"
          required
          [attr.aria-label]="'Минимальный остаток: ' + row.warehouseName"
          [ngModel]="row.draft"
          (ngModelChange)="changeDraft(row, $event)"
          [disabled]="row.saving"
          (keydown.enter)="save(row)"
        />
        <mat-error>Целое число от 0 до 1 000 000</mat-error>
      </mat-form-field>
      <button
        type="button"
        mat-stroked-button
        class="save-button"
        [disabled]="row.saving || !validDraft(row) || row.draft === row.minimumStock"
        [attr.aria-label]="'Сохранить минимум: ' + row.warehouseName"
        (click)="save(row)"
      >
        {{ row.saving ? 'Сохранение…' : 'Сохранить' }}
      </button>
      <div *ngIf="!validDraft(row)" class="row-message error" role="alert">
        Введите целое число от 0 до 1 000 000.
      </div>
      <div *ngIf="row.error" class="row-message error" role="alert">{{ row.error }}</div>
      <div *ngIf="row.saved" class="row-message success" role="status">Сохранено</div>
    </div>
  </div>
</section>
